module.exports = __webpack_public_path__ + "static/media/1023142.0c097223.png";